export const toPixels = (value: string): number => {
  const trimmed = value.trim();

  if (trimmed.endsWith('px')) {
    return parseFloat(trimmed);
  }

  if (trimmed.endsWith('em') || trimmed.endsWith('rem')) {
    return parseFloat(trimmed) * 16;
  }

  return parseFloat(trimmed);
};
